export enum ETelemetryEvents {
  SearchSuggestionLinkSuccess = 'suggestion.search-suggestion-link.success',
  SearchSuggestionLinkFail = 'suggestion.suggestion.search-suggestion-link.fail',
  FirstSuggestionLinkSuccess = 'suggestion.first-suggestion-link.success',
  FirstSuggestionLinkFail = 'suggestion.first-suggestion-link.fail',
  NotFoundSuggestionsSuccess = 'suggestion.not-found.success',
  FirstSuggestionNotFound = 'suggestion.first-suggestion-not-found',
}
